export default __webpack_public_path__ + "static/media/Levitate D2.1 Dissemination strategy.75a0d70b.pdf";